// extracted by mini-css-extract-plugin
module.exports = {"user-avatar":"UserImage_user-avatar__gBSy0"};